export const handleInputChange = (e,setText,text,type) => {
    const { name, value } = e.target;
    setText({...text, [name]: value})
}

export const handleImageUpload = (e,setImage, image) => {
    const pickedFile = [...image.files,...e.target.files]
    let fileToRemove = pickedFile.length > 5 ? pickedFile.length - 5 : 0
    let newArr = pickedFile.length > 5 ? pickedFile.splice(fileToRemove, 5) : pickedFile;
    setImage({files: newArr})
}